/* VE24H mini-cart popup — intercepte les ajouts au panier et affiche une confirmation */
(function(){
  'use strict';

  var POPUP_ID = 've24h-cart-popup';

  // Locale: FR par défaut, EN si <html lang="en">
  var IS_EN = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
  var T = IS_EN ? {
    added: '✓ Added to cart',
    addedLabel: 'Product added to cart',
    close: 'Close',
    viewCart: 'View cart',
    keepShopping: 'Continue shopping',
    product: 'Product',
    moneyLocale: 'en-CA',
    cartPath: '/en/cart'
  } : {
    added: '✓ Ajouté au panier',
    addedLabel: 'Produit ajouté au panier',
    close: 'Fermer',
    viewCart: 'Voir le panier',
    keepShopping: 'Continuer mes achats',
    product: 'Produit',
    moneyLocale: 'fr-CA',
    cartPath: '/cart'
  };

  function money(cents){
    try {
      return (cents/100).toLocaleString(T.moneyLocale,{style:'currency',currency:'CAD'});
    } catch(e){ return (cents/100).toFixed(2)+' $'; }
  }

  function ensurePopup(){
    var p = document.getElementById(POPUP_ID);
    if(p) return p;
    p = document.createElement('div');
    p.id = POPUP_ID;
    p.innerHTML =
      '<div class="ve24h-popup-overlay" data-close></div>'+
      '<div class="ve24h-popup-box" role="dialog" aria-label="'+T.addedLabel+'">'+
        '<button class="ve24h-popup-x" data-close aria-label="'+T.close+'">×</button>'+
        '<div class="ve24h-popup-head">'+T.added+'</div>'+
        '<div class="ve24h-popup-product">'+
          '<img class="ve24h-popup-img" src="" alt="">'+
          '<div class="ve24h-popup-info">'+
            '<div class="ve24h-popup-title"></div>'+
            '<div class="ve24h-popup-variant"></div>'+
            '<div class="ve24h-popup-price"></div>'+
          '</div>'+
        '</div>'+
        '<div class="ve24h-popup-actions">'+
          '<a href="'+T.cartPath+'" class="ve24h-popup-btn ve24h-popup-btn-primary">'+T.viewCart+'</a>'+
          '<button class="ve24h-popup-btn ve24h-popup-btn-secondary" data-close>'+T.keepShopping+'</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(p);
    p.addEventListener('click', function(e){
      if(e.target.closest('[data-close]')) hidePopup();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') hidePopup();
    });
    return p;
  }

  function showPopup(item){
    var p = ensurePopup();
    var img = p.querySelector('.ve24h-popup-img');
    if(item.image){ img.src = item.image; img.style.display=''; }
    else { img.style.display='none'; }
    p.querySelector('.ve24h-popup-title').textContent = item.product_title || item.title || T.product;
    p.querySelector('.ve24h-popup-variant').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    p.querySelector('.ve24h-popup-price').textContent = money(item.final_price || item.price);
    p.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(){
    var p = document.getElementById(POPUP_ID);
    if(p) p.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      }).catch(function(){});
  }

  function handleAddToCart(form){
    var fd = new FormData(form);
    // ensure quantity
    if(!fd.get('quantity')) fd.set('quantity','1');
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
    })
    .then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function(item){
      updateCartCount();
      showPopup(item);
    })
    .catch(function(){
      // fallback: submit normally
      form.submit();
    });
  }

  // Intercepte les formulaires d'ajout au panier (capture phase, avant le thème)
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action')||'').toLowerCase();
    if(action.indexOf('/cart/add') === -1) return;
    // ignore si le form est dans notre popup
    if(form.closest('#'+POPUP_ID)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    handleAddToCart(form);
  }, true);

  // Expose pour debug
  window.ve24hHideCartPopup = hidePopup;
})();
